import { render, staticRenderFns } from "./ProjectsPage.vue?vue&type=template&id=63305236&scoped=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=63305236&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63305236",
  null
  
)

export default component.exports